export { wrapPageElement } from "./src/components/WrapPage"

// Dagnavigatie op de statistiekpagina (PLAN-STATS fase 3): verandert alleen de zoekstring (?date=), dan blijft de scrollpositie staan.
export const shouldUpdateScroll = ({routerProps, prevRouterProps}) => {
    const prev = prevRouterProps && prevRouterProps.location
    const next = routerProps && routerProps.location
    return !(prev && next && prev.pathname === next.pathname && prev.search !== next.search)
}
